import {Component, Input, OnInit} from '@angular/core';
import {CommonService} from '../../core/service/common.service';
import {SessionService} from '../../core/service/session.service';
import {EventService} from '../../core/service/event.service';
import {ShiyoulotService} from '../../core/service/shiyoulot.service';
import {yyyyMMdd} from '../../shared/typeAliases';
import {AbstractEvent} from '../../shared/interfaces/abstract-event';

const TAISHOU_EDUKE_DATE = 'taishouEdukeDate';
const YOTEI_DATE = 'yoteiDate';
const YOTEI_NICHIREI = 'yoteiNichirei';

interface EventEditForm {
  [TAISHOU_EDUKE_DATE]: yyyyMMdd,
  [YOTEI_DATE]: yyyyMMdd,
  [YOTEI_NICHIREI]: number
}

@Component({
  selector: 'app-event-edit',
  templateUrl: './event-edit.component.html',
  styleUrls: ['./event-edit.component.scss']
})
export class EventEditComponent implements OnInit {
  @Input() selectedMeisais: AbstractEvent[] = [];
  eventEditForm: EventEditForm = this.getInitialEventEditForm();

  constructor(public commonService: CommonService,
              public sessionService: SessionService,
              public shiyoulotService: ShiyoulotService,
              public eventService: EventService,) {
  }

  /**
   *
   */
  ngOnInit(): void {
    this.eventEditForm = this.genEventEditForm(this.selectedMeisais[0]);
  }

  /**
   *
   * @param eventEditForm
   * @param selectedMeisais
   */
  updateEventYoteiDate(eventEditForm: Required<EventEditForm>, selectedMeisais: AbstractEvent[]) {
    if (!eventEditForm.yoteiDate || !eventEditForm.yoteiNichirei && eventEditForm.yoteiNichirei != 0) {
      alert('値が入力されていません。');
      return;
    }
    if (eventEditForm.yoteiNichirei < 0) {
      alert('予定日齢がマイナスになっています。');
      return;
    }
    const dateList = selectedMeisais.map((row: AbstractEvent) => {
      return [row[YOTEI_DATE]];
    }).reduce((a: yyyyMMdd[], b: yyyyMMdd[]) => {
      return a.concat(b);
    });
    const set = Array.from(new Set(dateList));
    if (set.length > 1) {
      if (!confirm('違う予定日の作業が含まれています。このまま更新しますか？')) {
        return;
      }
    }

    selectedMeisais.forEach((meisai: AbstractEvent) => {
      this.commonService.keysOf(this.eventEditForm).forEach(key => {
        if (key === YOTEI_DATE && eventEditForm[key]) { meisai[key] = eventEditForm[key]; }
        if (key === YOTEI_NICHIREI) { meisai[key] = this.commonService.calcNichirei(meisai.taishouEdukeDate, eventEditForm.yoteiDate); }
      });
    });

    this.eventService.updateEvents(selectedMeisais);
  }

  /**
   * 初期値セット
   */
  getInitialEventEditForm(): EventEditForm {
    return {
      taishouEdukeDate: this.commonService.getDateWithString(),
      yoteiDate: this.commonService.getDateWithString(),
      yoteiNichirei: 0,
    };
  }

  /**
   * イベント明細の値をセット
   * @param selectedMeisai
   */
  genEventEditForm(selectedMeisai: AbstractEvent): EventEditForm {
    return {
      taishouEdukeDate: selectedMeisai.taishouEdukeDate,
      yoteiDate: selectedMeisai.yoteiDate,
      yoteiNichirei: selectedMeisai.yoteiNichirei,
    };
  }

  /**
   * EventEditForm 予定日齢を更新
   * @param eventEditForm
   */
  updateEventEditFormYoteiNichirei(eventEditForm: EventEditForm) {
    if (eventEditForm.taishouEdukeDate && eventEditForm.yoteiDate) {
      eventEditForm.yoteiNichirei = this.commonService.calcNichirei(eventEditForm.taishouEdukeDate, eventEditForm.yoteiDate);
    }
  }

  /**
   * EventEditForm 予定日を更新
   * @param eventEditForm
   */
  updateEventEditFormYoteiDate(eventEditForm: EventEditForm) {
    eventEditForm.yoteiDate = this.commonService.genOffsetDateWithStandardDateString(eventEditForm.taishouEdukeDate, eventEditForm.yoteiNichirei -1);
  }
}
